import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { cssColor } from "@stenajs-webui/theme";
import { Column, Indent, Text } from "@stenajs-webui/core";
import React from "react";
import { NegotiationYearSelect } from "@/components/data-driven-inputs/selects/negotiation-year-select/NegotiationYearSelect";
import { useDefaultYearSelection } from "../../../../hooks/UseDefaultYearSelection";

interface Props {
  setYear: (year: number) => void;
}

export const NegotiationYearSelector: React.FC<Props> = ({ setYear }) => {
  const { year, handleYearChange, loading } = useDefaultYearSelection();
  const respondToYearChange = (newYear: number) => {
    handleYearChange(newYear);
    setYear(newYear);
  };

  return (
    <>
      <Text size="small" color={cssColor("--lhds-color-ui-500")}>
        Negotiation year
      </Text>
      <Indent num={0.5} />
      <Column width={100}>
        <NegotiationYearSelect
          isLoading={loading}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: ZIndex.highest,
            }),
          }}
          value={year}
          onValueChange={(value) => respondToYearChange(value)}
        />
      </Column>
    </>
  );
};
